// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__3vbKG","modalHeader":"styles_modalHeader__2yE9r","btnClose":"styles_btnClose__2DKnO","btnContainer":"styles_btnContainer__36YLr"};